function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import memoize from 'memoize-one';
class MarkdownUtils {
  /**
   * Retrieves a new markdown title that does not conflict with the current titles
   * @param usedTitles Markdown titles that are already in use
   * @returns The new title
   */
  static getNewMarkdownTitle(usedTitles) {
    var title = "".concat(MarkdownUtils.DEFAULT_TITLE);
    var titleIndex = 0;
    while (usedTitles.indexOf(title) >= 0) {
      titleIndex += 1;
      title = "".concat(MarkdownUtils.DEFAULT_TITLE, "-").concat(titleIndex);
    }
    return title;
  }
}
_defineProperty(MarkdownUtils, "DEFAULT_TITLE", 'Note');
_defineProperty(MarkdownUtils, "DEFAULT_CONTENT", '# Markdown Note\n\nThis note can be edited using **markdown** for styling.');
_defineProperty(MarkdownUtils, "getClosedMarkdowns", memoize(closedPanels => closedPanels.filter(panel => panel.component === 'MarkdownPanel' && panel.props.panelState.content !== '' && panel.props.panelState.content !== null).reverse()));
export default MarkdownUtils;
//# sourceMappingURL=MarkdownUtils.js.map